export default __webpack_public_path__ + "static/media/03d_fold-16.fc49f5a7.mp4";